import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfirmationMessageComponent } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/components/confirmation-message/confirmation-message.component';
import { TipoMensajeConfirmacion } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/models/confirmation-message-data';
import { DocumentoEnvioSimple } from '../../models/documento-envio-simple';
import { EnvioSimpleFlowService } from '../../services/envio-simple-flow.service';

@Component({
  selector: 'app-envio-simple-ficheros-subidos',
  templateUrl: './envio-simple-ficheros-subidos.component.html',
  styleUrls: ['./envio-simple-ficheros-subidos.component.css']
})
export class EnvioSimpleFicherosSubidosComponent implements OnInit, OnDestroy {
  /** Texto del encabezado de la lista. */
  @Input() titulo = 'Ficheros subidos';
  /** Disposicion de las tarjetas: horizontal (paso Documentos) o vertical (paso Firmantes). */
  @Input() orientacion: 'horizontal' | 'vertical' = 'horizontal';
  /** Habilita la seleccion de documento activo con sombreado de la miniatura. */
  @Input() seleccionable = false;
  /** Oculta acciones de edicion (eliminar/reordenar) para vistas de solo lectura. */
  @Input() soloLectura = false;

  documentos: DocumentoEnvioSimple[] = [];
  documentoActivoId: string | null = null;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private envioSimpleFlowService: EnvioSimpleFlowService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.envioSimpleFlowService.documentos$
      .pipe(takeUntil(this.destroy$))
      .subscribe(documentos => {
        this.documentos = [...documentos];
      });

    this.envioSimpleFlowService.documentoActivoId$
      .pipe(takeUntil(this.destroy$))
      .subscribe(id => {
        this.documentoActivoId = id;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  seleccionarDocumento(id: string): void {
    if (!this.seleccionable) {
      return;
    }
    this.envioSimpleFlowService.seleccionarDocumentoActivo(id);
  }

  eliminarDocumento(id: string): void {
    // Si el documento tiene gadgets configurados, pedir confirmacion antes de
    // quitarlo; sin gadgets se elimina directamente (fase 6.1 / 6.2).
    if (this.envioSimpleFlowService.documentoTieneGadgets(id)) {
      this.confirmarEliminarDocumentoConGadgets(id);
      return;
    }
    this.envioSimpleFlowService.eliminarDocumento(id);
  }

  private confirmarEliminarDocumentoConGadgets(id: string): void {
    const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
      data: {
        tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
        icono: 'icon-delete',
        titulo: '¿Eliminar documento?',
        mensaje: 'Se eliminarán también los elementos del firmante configurados en este documento.',
        textoConfirmacion: 'Quitar documento',
        iconoConfirmacion: 'icon-delete',
        textoCancelar: 'Cancelar'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'OK') {
        this.envioSimpleFlowService.eliminarDocumento(id);
      }
    });
  }

  reordenar(event: CdkDragDrop<DocumentoEnvioSimple[]>): void {
    if (event.previousIndex === event.currentIndex) {
      return;
    }

    moveItemInArray(this.documentos, event.previousIndex, event.currentIndex);
    this.envioSimpleFlowService.reordenarDocumentos(this.documentos);
  }

  trackById(_index: number, documento: DocumentoEnvioSimple): string {
    return documento.id;
  }
}
